var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"title":"多余文件,请删除"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('a-icon',{attrs:{"type":"smile","theme":"twoTone"}})]},proxy:true},{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.returnIndex}},[_vm._v(" 返回首页 ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }